import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { ResourceService } from '@teem/generic/resource.service';
import { quotation as QuotationApi } from '@teem/constants/api';
import { Quotation, QuotationSerializer } from '@teem/models/quotation';

@Injectable({
  providedIn: 'root'
})
export class QuotationService extends ResourceService<Quotation>{

  constructor(httpClient: HttpClient) {
    super(
      httpClient,
      QuotationApi.endPoint,
      new QuotationSerializer()
    )
  }

  public action(params: any) {
    return this.httpClient.patch(`${QuotationApi.action}`, params);
  }

  public list(): Observable<Quotation[]> {
    return this.httpClient.get(`${QuotationApi.list}`, this.httpOptions)
      .pipe(map((r: any) => this.convertData(r)));
  }

  public stats() {
    return this.httpClient.get(`${QuotationApi.stats}`, this.httpOptions);
  }

  public commonData() {
    return this.httpClient.get(`${QuotationApi.common}`, this.httpOptions);
  }

  public getProductAndServices() {
    return this.httpClient.get(`${QuotationApi.products_services_list}`)
  }
  
  public rejectReason(params: any) {
    return this.httpClient.post(`${QuotationApi.reject_reason}`, params);
  }
  
}
